/**
 * Configuration for conversation context and history management
 */
export const CONTEXT_CONFIG = {
  /**
   * Maximum number of previous UIBlocks to include as conversation context
   * Set to 0 to disable conversation history
   * Higher values provide more context but may increase token usage
   */
  MAX_CONVERSATION_CONTEXT_BLOCKS: 3,
};
